module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/ten.dbd080d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/ten.jpg
// module id = tc3W
// module chunks = 0